<aside class="sidebar" [class.collapsed]="collapsed">
  <!-- Logo area -->
  <div class="sidebar__logo">
    <div class="logo-container g-cursor-pointer" routerLink="/">
      <img [src]="logo" alt="AAAASF Logo" class="logo-img" />
    </div>
  </div>

  <!-- Search input -->
  <div class="sidebar__search" *ngIf="!collapsed">
    <div class="search-wrapper" [ngClass]="'search-mode-' + searchMode">
      <mat-icon class="search-icon">
        {{ searchMode === 'facility' ? 'business' : searchMode === 'survey' ? 'assignment' : searchMode === 'invoice' ? 'receipt' : searchMode === 'user' ? 'person' : 'search' }}
      </mat-icon>
      <input
        type="text"
        class="search-input"
        [placeholder]="searchMode === 'facility' ? 'Search facilities by ID or name...' :
                       searchMode === 'survey' ? 'Search surveys...' :
                       searchMode === 'invoice' ? 'Search invoices...' :
                       searchMode === 'user' ? 'Search users...' :
                       'Search... (! # $ @)'"
        [(ngModel)]="searchQuery"
        (input)="onSearchInput()"
        (blur)="onSearchBlur()"
        (focus)="onSearchFocus()"
      />
    </div>
    <!-- Search results dropdown -->
    <div class="search-results" *ngIf="showSearchResults">
      <!-- Search hint when just prefix typed -->
      <div class="search-hint" *ngIf="searchMode !== 'module' && searchResults.length === 0 && !searchLoading">
        <mat-icon class="hint-icon">info_outline</mat-icon>
        <span *ngIf="searchMode === 'facility'">Type a facility ID or name after #</span>
        <span *ngIf="searchMode === 'survey'">Type a survey ID or keyword after !</span>
        <span *ngIf="searchMode === 'invoice'">Type an invoice number or keyword after $</span>
        <span *ngIf="searchMode === 'user'">Type a user name or email after &#64;</span>
      </div>
      <!-- Loading state -->
      <div class="search-loading" *ngIf="searchLoading">
        <mat-icon class="loading-icon">hourglass_empty</mat-icon>
        <span>Searching {{ searchMode === 'facility' ? 'facilities' : searchMode === 'survey' ? 'surveys' : searchMode === 'invoice' ? 'invoices' : 'users' }}...</span>
      </div>
      <!-- Results -->
      <div
        class="search-result-item"
        [ngClass]="result.type + '-result'"
        *ngFor="let result of searchResults"
        (mousedown)="onSearchResultClick(result)"
      >
        <mat-icon *ngIf="result.icon && !result.customIcon" class="result-icon">{{ result.icon }}</mat-icon>
        <mat-icon *ngIf="result.customIcon" class="result-icon custom" [svgIcon]="result.customIcon"></mat-icon>
        <div class="result-text">
          <span class="result-title">{{ result.title }}</span>
          <span class="result-subtitle" *ngIf="result.subtitle">{{ result.subtitle }}</span>
          <span class="result-breadcrumb" *ngIf="result.breadcrumb">{{ result.breadcrumb }}</span>
        </div>
      </div>
      <!-- No results -->
      <div class="search-empty" *ngIf="!searchLoading && searchResults.length === 0 && searchMode !== 'module' && searchQuery.length > 1">
        <span>No {{ searchMode === 'facility' ? 'facilities' : searchMode === 'survey' ? 'surveys' : searchMode === 'invoice' ? 'invoices' : 'users' }} found</span>
      </div>
    </div>
  </div>

  <!-- Search icon button when collapsed -->
  <div class="sidebar__search-collapsed" *ngIf="collapsed">
    <button mat-icon-button (click)="expandSidebarForSearch()" matTooltip="Search">
      <mat-icon>search</mat-icon>
    </button>
  </div>

  <!-- Primary navigation -->
  <nav class="sidebar__nav">
    <ul class="nav-list">
      <li *ngFor="let item of primaryNavItems" class="nav-item">
        <a
          *appPermissions="item.permissionLink"
          class="nav-link"
          [routerLink]="item.route"
          routerLinkActive="active"
          [matTooltip]="collapsed ? item.title : ''"
          matTooltipPosition="right"
        >
          <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
          <span class="nav-label" *ngIf="!collapsed">{{ item.title }}</span>
        </a>

        <!-- Sub-nav items (nested under active nav item) -->
        <ul
          class="sub-nav-list"
          *ngIf="!collapsed && activeNavItem === item && subMenuItems.length > 0"
        >
          <li *ngFor="let sub of subMenuItems" class="sub-nav-item">
            <a
              *appPermissions="sub.permissionLink"
              class="sub-nav-link"
              [ngClass]="{'active': isSubItemActive(sub.url), 'disabled': sub.disabled}"
              (click)="navigateSideMenu(sub.url)"
              [routerLink]="sub.url"
            >
              <mat-icon
                class="sub-nav-icon"
                [ngClass]="{'custom': !!sub.customIcon}"
                [svgIcon]="sub.customIcon"
              >{{ sub.icon }}</mat-icon>
              <span class="sub-nav-label">{{ sub.title }}</span>
            </a>

            <!-- Nested sub-items (e.g., Reports > CMS > Monthly) -->
            <ul *ngIf="sub?.subItems?.length > 0" class="nested-sub-list">
              <li *ngFor="let nested of sub.subItems" class="nested-sub-item">
                <a
                  *appPermissions="nested.permissionLink"
                  class="nested-sub-link"
                  [ngClass]="{'active': isSubItemActive(nested.url), 'disabled': nested.disabled}"
                  [routerLink]="nested.url"
                >
                  <mat-icon
                    class="nested-sub-icon"
                    [ngClass]="{'custom': !!nested.customIcon}"
                    [svgIcon]="nested.customIcon"
                  >{{ nested.icon }}</mat-icon>
                  <span class="nested-sub-label">{{ nested.title }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <!-- QBO connect item -->
      <li class="nav-item" *appPermissions="qboPermission">
        <a
          *ngIf="!qboConnected"
          class="nav-link"
          (click)="connectToQbo()"
          [matTooltip]="collapsed ? qboNavItem.title : ''"
          matTooltipPosition="right"
        >
          <mat-icon class="nav-icon">{{ qboNavItem.icon }}</mat-icon>
          <span class="nav-label" *ngIf="!collapsed">{{ qboNavItem.title }}</span>
        </a>
      </li>
    </ul>
  </nav>

  <!-- Bottom section -->
  <div class="sidebar__bottom">
    <!-- User profile row -->
    <div class="user-row">
      <button
        [matMenuTriggerFor]="userMenu"
        class="user-button"
        [matTooltip]="collapsed ? displayName : ''"
        matTooltipPosition="right"
      >
        <div class="user-avatar" [ngStyle]="{'background-image': 'url(' + avatar + ')'}"></div>
        <div class="user-info" *ngIf="!collapsed">
          <span class="user-name">{{ displayName }}</span>
          <span class="user-role">Staff</span>
        </div>
      </button>
      <mat-menu #userMenu="matMenu">
        <button (click)="myProfile()" mat-menu-item>My profile</button>
        <button mat-menu-item [routerLink]="logoutPath">Log out</button>
      </mat-menu>

      <!-- Notification bell -->
      <button
        class="notification-btn"
        (click)="myNotifications()"
        *ngIf="!collapsed"
        matTooltip="Notifications"
      >
        <mat-icon class="notification-bell-icon">notifications</mat-icon>
        <span class="notification-badge" *ngIf="notificationCount > 0">
          {{ notificationCount }}
        </span>
      </button>
    </div>

    <!-- Notification icon when collapsed -->
    <button
      class="notification-btn notification-btn--collapsed"
      (click)="myNotifications()"
      *ngIf="collapsed"
      matTooltip="Notifications"
      matTooltipPosition="right"
    >
      <mat-icon class="notification-bell-icon">notifications</mat-icon>
      <span class="notification-badge" *ngIf="notificationCount > 0">
        {{ notificationCount }}
      </span>
    </button>
  </div>

  <!-- Toggle button -->
  <button class="sidebar__toggle" (click)="toggleSidebar()">
    <mat-icon>{{ collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </button>
</aside>
